import { ReactNode, useRef } from "react";
import { useIntl } from "react-intl";
import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";
import AppHeader from "../../features/header/AppHeader";
import { AppContext } from "../../layout/AppContext";

interface BackofficeLayoutProps {
  children: ReactNode;
  submenu?: ReactNode;
}

const BackofficeLayout = ({ children, submenu }: BackofficeLayoutProps) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const intl = useIntl();

  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout className="MyServiceLayout bg-lighter height-500">
        <ApplicationLayout.Header>
          <AppHeader
            navItems={[
              {
                key: "backoffice/consultants",
                value: intl.formatMessage({ id: "intl-msg:backoffice.consultantList.title" }),
              },
              {
                key: "backoffice/failures",
                value: intl.formatMessage({ id: "intl-msg:backoffice.failuresList.title" }),
              },
              {
                key: "backoffice/steps",
                value: intl.formatMessage({ id: "intl-msg:backoffice.stepsList.title" }),
              },
              {
                key: "backoffice/budget",
                value: intl.formatMessage({ id: "intl-msg:budgets.form.detailTitle.title" }),
              },
            ]}
          />
        </ApplicationLayout.Header>
        <ApplicationLayout.Body className="uikitDemo" navigation={submenu}>
          {children}
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default BackofficeLayout;
